export default __webpack_public_path__ + "static/media/sidebar.2a029822.svg";